import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { AuthProviderEnum } from '@onesource/schemas';
import axios from '../axios';
import { setSession } from './session';

type TSupabaseLoginPayload = {
  identifier: string;
  password: string;
};

type TSupabaseLoginResponse = {
  access_token: string;
  refresh_token: string;
  user: {
    email: string;
  };
};

type TGenerateOttPayload = {
  targetApp: string;
  redirectUrl: string;
  email?: string;
};

export const supabaseLoginMutationFn = async (payload: TSupabaseLoginPayload) => {
  const { data } = await axios.post<TSupabaseLoginResponse>('/auth/supabase-login', {
    identifier: payload.identifier,
    password: payload.password,
  });

  setSession({
    token: data.access_token,
    refreshToken: data.refresh_token,
    user: {
      email: data.user.email || '',
      name: data.user.email?.split('@')[0] || 'User',
    },
    authProvider: AuthProviderEnum.supabase,
  });

  return data;
};

export const useSupabaseLoginMutation = () => {
  return useMutation({
    mutationFn: supabaseLoginMutationFn,
    meta: {
      errorMessage: 'Incorrect email or password. Please try again or reset your password.',
    },
  });
};

export const generateOttMutationFn = async (payload: TGenerateOttPayload) => {
  const { data } = await axios.post<{ redirectUrl: string }>('/auth/generate-ott/user', payload);
  return data;
};

export const useGenerateOttMutation = () => {
  return useMutation({
    mutationFn: generateOttMutationFn,
  });
};

export const getSupabaseLoginErrorMessage = (error: Error): string => {
  if (error instanceof AxiosError) {
    return error.response?.data?.message || error.message || 'Login failed. Please try again.';
  }
  return error.message || 'Login failed. Please try again.';
};
